import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GrpcFactoryService } from '../../sharedServices/grpc-factory.service';
import { DeliveryServiceClient } from '../../api/ph-web/delivery/delivery.apiServiceClientPb';
import {
  CancelTaskByIdRequest,
  CoordinatesClientData,
  DeliveryCoordinates,
  EvidenceFilter,
  GetAddressInGeologicRequest,
  GetAddressInGeologicResponse,
  GetCalculateRequest,
  GetCalculateResponse,
  GetCalculationDistanceRequest,
  GetCancellationRateRequest,
  GetCancellationRateResponse,
  GetCancellationTypesRequest,
  GetCancellationTypesResponse,
  GetDeliveryDetailByIdRequest,
  GetDeliveryDetailByIdResponse,
  GetDeliveryDetailByUUIDRequest,
  GetEvidencesByTaskIdRequest,
  GetEvidencesByTaskIdResponse,
  GetEvidencesZipByTaskIdResponse,
  GetExpressTaskHistoryRequest,
  GetExpressTaskHistoryResponse,
  GetRatebyTaskIdRequest,
  GetResourcesByUserRequest,
  GetResourcesByUserResponse,
  OauthTokenRequest,
  OauthTokenResponse,
  RateTaskbyIdRequest,
  ServiceTypeEnum,
  SimplifiedCoordinates,
  StatusInfoResponse,
} from '../../api/ph-web/delivery/delivery.api_pb';
import { OrderToCreateShared } from '../../models/interface/orderToCreate.interface';
import { CalculateShared } from '../../models/interface/calculate.interface';
import { RateOrderShared } from '../../models/interface/rateOrder.interface';
import { LogsService } from '../../sharedServices/logs.service';
import { LogsType } from '../../models/interface/logsType.enum';
import { ServiceStatus } from '../../models/interface/serviceStatus.enum';
import { ItemNumberToFilterShared } from '../../models/interface/itemNumberToFilter.interface';
import { RequestAddressErrorKey } from '../../models/interface/requestAddressErrorKey.enum';
import { RequestAddressErrorMessage } from '../../models/interface/requestAddressErrorMessage.enum';
import { CoordinateShared } from '../../models/interface/coordinate.interface';
import { OrderDistanceShared } from '../../models/interface/orderDistance.interface';
import { UtilsService } from '../../sharedServices/utils.service';
import { CityAndToFilterShared } from '../../models/interface/cityAndToFilter.interface';
import { CityShared } from '../../models/interface/cityShared.interface';
import { PackageEvidenceFilterShared } from '../../models/interface/packageEvidenceFilter.interface';
import { EvidenceShared } from '../../models/interface/evidence.interface';
import { CountryShared } from '../../models/interface/country.interface';
import { MuExceptionData } from '../../models/interface/muExceptionData.interface';
import { MuException } from '../../types/exception.type';
import { CancelOrderShared } from '../../models/interface/cancelOrder.interface';
import { LoginCredentialsShared } from '../../models/interface/loginCredentials.interface';
import { OauthResponseShared } from '../../models/interface/oauthResponse.interface';
import { UserDataShared } from '../../models/interface/userData.interface';
import { OauthTokenShared } from '../../models/interface/oAuthToken.interface';
import { sharedAuthConstants } from '../../sharedConstants/auth.constants';
import { OrderDetailShared } from '../../models/interface/orderDetail.interface';
import { ExpressServiceStatus } from '../../models/interface/expressServiceStatus.enum';
import { sharedDeliveryConstants } from '../../sharedConstants/delivery.constants';
import { OrderType } from '../../models/interface/orderType.enum';
import { OrderStopType } from '../../models/interface/orderStopType.enum';
import { OrderStopShared } from '../../models/interface/orderStop.interface';
import { WayToPay } from '../../models/interface/wayToPay.enum';
import { OrderStopMapShared } from '../../models/interface/orderStopMap.interface';
import { PackageDetailTrackStopStatusShared } from '../../models/interface/packageDetailTrackStopStatus.interface';
import { TranslateService } from '@ngx-translate/core';
import { BaseHistoryItemShared } from '../../models/interface/baseHistoryItem.interface';
import { QualificationOrderShared } from '../../models/interface/qualificationOrder.interface';
import { MuHttpService } from '../../sharedServices/mu-http.service';

@Injectable({
  providedIn: 'root',
})
export class MuDeliveryService {
  private deliveryClient = this.grpcFactoryService.create(
    DeliveryServiceClient,
    `${environment.hostname}${environment.hostPort}`,
    'DeliveryServiceClient'
  );
  private getCalculateCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.getCalculate,
    {
      callName: 'getCalculate',
    }
  );
  private getEvidenceListCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.getEvidencesByTaskId,
    {
      callName: 'getEvidencesByTaskId',
    }
  );
  private getEvidenceZipCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.getEvidencesZipByTaskId,
    {
      callName: 'getEvidencesZipByTaskId',
    }
  );
  private rateOrderCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.rateTaskbyId,
    {
      callName: 'rateTaskbyId',
    }
  );
  private getRatebyTaskIdCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.getRatebyTaskId,
    {
      callName: 'getRatebyTaskId',
    }
  );
  private cancelOrderCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.cancelTaskById,
    {
      callName: 'cancelTaskById',
    }
  );
  private getCancellationTypeListCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.getCancellationTypes,
    {
      callName: 'getCancellationTypes',
    }
  );
  private getOrderChargeCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.getCancellationRate,
    {
      callName: 'getCancellationRate',
    }
  );
  private getAddressInGeologicCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.getAddressInGeologic,
    {
      callName: 'getAddressInGeologic',
    }
  );
  private getCalculationDistanceCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.getCalculationDistance,
    {
      callName: 'getCalculationDistance',
    }
  );
  private getCityListCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.getCities,
    {
      callName: 'getCities',
    }
  );
  private getOauthTokenCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.oauthToken,
    {
      callName: 'oauthToken',
    }
  );
  private getUserDataCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.getResourcesByUser,
    {
      callName: 'getResourcesByUser',
    }
  );
  private getDeliveryDetailById = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.getDeliveryDetailById,
    {
      callName: 'getDeliveryDetailById',
    }
  );
  private getDeliveryDetailByUuid = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.getDeliveryDetailByUUID,
    {
      callName: 'getDeliveryDetailByUUID',
    }
  );
  private getServiceHistoryCall = this.grpcFactoryService.call(
    this.deliveryClient,
    this.deliveryClient.getExpressTaskHistory,
    {
      callName: 'getExpressTaskHistory',
    }
  );

  constructor(
    private grpcFactoryService: GrpcFactoryService,
    private logsService: LogsService,
    private utilsService: UtilsService,
    private translateService: TranslateService,
    private Muhttp: MuHttpService
  ) {
    /** */
  }

  /**
   * get calculate cost delivery
   *
   * @param {OrderToCreateShared} orderDataToCalculate
   * @return {*}  {Promise<CalculateShared>}
   * @memberof MuDeliveryService.getCalculate
   */
  async getCalculate(orderDataToCalculate: OrderToCreateShared): Promise<CalculateShared> {
    const request: GetCalculateRequest = new GetCalculateRequest();
    request.setUserid(orderDataToCalculate.userId);
    request.setServicetype(orderDataToCalculate.serviceType);
    request.setRoundtrip(orderDataToCalculate.roundTrip);
    request.setCity(orderDataToCalculate.city);
    request.setDeclaredvalue(parseFloat(orderDataToCalculate.declaredValue));
    request.setPromotionalcode(orderDataToCalculate.promotionalCode);

    const coordinateList: SimplifiedCoordinates[] = [];

    for (const coordinate of orderDataToCalculate.coordinates) {
      const newCoordinate = new SimplifiedCoordinates();
      newCoordinate.setAddress(coordinate.address);
      newCoordinate.setLatitude(coordinate.latitude);
      newCoordinate.setLongitude(coordinate.longitude);
      newCoordinate.setCity(coordinate.city);
      coordinateList.push(newCoordinate);
    }
    request.setCoordinatesList(coordinateList);

    const response: GetCalculateResponse = await this.getCalculateCall(request);
    const message = response.getStatus();

    if (response.getApimessage() !== 'OK' || response.getStatuscode() !== 0) {
      throw new MuException({
        message,
      });
    }

    return {
      baseValue: response.getData().getBasevalue(),
      distanceSurcharge: response.getData().getDistancesurcharge() || 0,
      surchargeStops: response.getData().getSurchargestops(),
      insuranceSurcharge: response.getData().getInsurancesurcharge(),
      percentageInsurance: response.getData().getPercentageinsurance(),
      roundtripSurcharge: response.getData().getRoundtripsurcharge(),
      nearbyCitySurcharge: response.getData().getNearbycitysurcharge() || 0,
      declaredValue: response.getData().getDeclaredvalue(),
      totalService: response.getData().getTotalservice(),
      totalDistance: response.getData().getTotaldistance(),
      totalSurcharge: response.getData().getTotalsurcharge(),
      stops: response.getData().getStops(),
      addDistancia: response.getData().getAdddistancia(),
      surchargeKM: response.getData().getSurchargekm(),
      roundtrip: response.getData().getRoundtrip(),
      discountedValue: response.getData().getDiscountedvalue(),
      totalServiceSd: response.getData().getTotalservicesd(),
      codeStatus: response.getData().getCodestatus(),
      otherValues: response.getData().getOthervalues(),
      surchargeTime: response.getData().getSurchargetime(),
      nightSurcharge: response.getData().getNightsurcharge(),
      parkingSurcharge: response.getData().getParkingsurcharge(),
      iva: response.getData().getIva(),
      percentageIva: response.getData().getPercentageiva(),
      discountType: response.getData().getDiscounttype(),
      codeMessage: response.getData().getCodemessage(),
    };
  }

  /**
   * Method to get evidences delivery
   *
   * @param {number} orderId
   * @param {PackageEvidenceFilter} filter
   * @returns {PackageEvidence}
   */
  async getEvidenceList(
    orderId: number,
    filter?: PackageEvidenceFilterShared
  ): Promise<EvidenceShared[]> {
    const request: GetEvidencesByTaskIdRequest = new GetEvidencesByTaskIdRequest();
    request.setTaskid(orderId.toString());
    if (filter?.taskPlaceId > 0) {
      const filterEvidence: EvidenceFilter = new EvidenceFilter();
      filterEvidence.setTaskplaceid(filter.taskPlaceId);
      request.setFilter(filterEvidence);
    }
    const response: GetEvidencesByTaskIdResponse = await this.getEvidenceListCall(request);
    return response?.getDataList()?.map(evidence => {
      return {
        orderId: evidence.getTaskid().toString(),
        urlPhoto: evidence.getUrlphoto(),
        date: evidence.getDate(),
        address: evidence.getAddress(),
      };
    });
  }

  /**
   * get evidence zip
   * @param {string} orderId
   * @param {PackageEvidenceFilterShared} filter
   * @returns {Unit8Array} response
   */
  async getEvidenceZip(orderId: string, filter?: PackageEvidenceFilterShared): Promise<Uint8Array> {
    const request: GetEvidencesByTaskIdRequest = new GetEvidencesByTaskIdRequest();
    request.setTaskid(orderId);
    if (filter?.taskPlaceId > 0) {
      const filterEvidence: EvidenceFilter = new EvidenceFilter();
      filterEvidence.setTaskplaceid(filter.taskPlaceId);
      request.setFilter(filterEvidence);
    }
    const response: GetEvidencesZipByTaskIdResponse = await this.getEvidenceZipCall(request);
    return response.getZipfile_asU8();
  }

  /**
   * rate order
   *
   * @param {RateOrderShared} rateOrder
   */
  async rateOrder(rateOrder: RateOrderShared): Promise<void> {
    const request: RateTaskbyIdRequest = new RateTaskbyIdRequest();
    request.setRate(rateOrder.rate);
    request.setDescription(rateOrder.description);
    request.setDevice(rateOrder.device);
    request.setQuestion(rateOrder.question);
    request.setVersion(rateOrder.version);
    request.setTaskid(rateOrder.id);
    await this.rateOrderCall(request);
  }

  /**
   * get rate data from task id
   *
   * @param {number} orderId
   */
  async getRateByTaskId(orderId: number): Promise<QualificationOrderShared> {
    const request: GetRatebyTaskIdRequest = new GetRatebyTaskIdRequest();
    request.setTaskid(orderId);
    request.setQuestion(7);
    request.setDevice(4);
    const rating = await this.getRatebyTaskIdCall(request);
    return {
      rate: rating?.getCalificacion(),
      description: rating?.getDescripcion(),
    };
  }

  /**
   * method to cancel order
   *
   * @param {CancelOrder} cancelOrder Cancel order data
   */
  async cancelOrder(cancelOrder: CancelOrderShared): Promise<void> {
    const orderCancelRequest = new CancelTaskByIdRequest();
    orderCancelRequest.setCancellationtype(cancelOrder.idRelation);
    orderCancelRequest.setDescription(cancelOrder.description || ' ');
    orderCancelRequest.setFinec(parseInt(cancelOrder.fineC, 10));
    orderCancelRequest.setFiner(parseInt(cancelOrder.fineR, 10));
    orderCancelRequest.setPayc(parseInt(cancelOrder.payC, 10));
    orderCancelRequest.setPayr(parseInt(cancelOrder.payR, 10));
    orderCancelRequest.setVerificationcode(cancelOrder.verificationCode);
    orderCancelRequest.setUserid(parseInt(cancelOrder.userId, 10));
    orderCancelRequest.setTaskid(parseInt(cancelOrder.orderId, 10));
    const response = await this.cancelOrderCall(orderCancelRequest);
    await this.logsService.buildLog({
      name: LogsType.CANCEL_ORDER,
      logFieldList: [
        {
          field: sharedDeliveryConstants.logs.field.cancelAt,
          value: new Date() + '',
          dataType: sharedDeliveryConstants.logs.dataType.string,
        },
        {
          field: sharedDeliveryConstants.logs.field.uuid,
          value: cancelOrder.uuid,
          dataType: sharedDeliveryConstants.logs.dataType.string,
        },
        {
          field: sharedDeliveryConstants.logs.field.userId,
          value: cancelOrder.userId,
          dataType: sharedDeliveryConstants.logs.dataType.int,
        },
        {
          field: sharedDeliveryConstants.logs.field.statusId,
          value: ServiceStatus.CANCELED + '',
          dataType: sharedDeliveryConstants.logs.dataType.int,
        },
      ],
      description: '',
      reportedBy: cancelOrder.userId,
    });

    if (response.getStatus() !== 'success') {
      throw new MuException({
        message: response.getApimessage(),
      });
    }
  }

  /**
   * get cancellation type list by business line
   *
   * @param {ServiceTypeEnum} serviceType
   * @returns {ItemNumberToFilterShared[]} response
   */
  async getCancellationTypeList(serviceType: ServiceTypeEnum): Promise<ItemNumberToFilterShared[]> {
    const request: GetCancellationTypesRequest = new GetCancellationTypesRequest();
    request.setServicetype(serviceType);
    const response: GetCancellationTypesResponse = await this.getCancellationTypeListCall(request);
    return response.getCancellationreasonsList().map(type => {
      return {
        value: type.getId(),
        label: type.getId().toString(),
        idRelation: type.getIdrelations(),
      };
    });
  }

  /**
   * get order charge by business line and country
   *
   * @param {number} orderId
   * @returns {number} response
   */
  async getOrderCharge(orderId: number): Promise<number> {
    const request: GetCancellationRateRequest = new GetCancellationRateRequest();
    request.setTaskid(orderId);
    const response: GetCancellationRateResponse = await this.getOrderChargeCall(request);
    return response.getCancellationrate();
  }

  /**
   * method to get address coordinates
   *
   * @param {string} geoName City Name
   * @param {string} address Address
   * @param {string} countryGeoName Country id
   * @return {Coordinates} coordinates Coordinates
   */
  async getAddressCoordinates(
    geoName: string,
    address: string,
    countryGeoName: string
  ): Promise<CoordinateShared> {
    const getAddressCoordinatesRequest = new GetAddressInGeologicRequest();
    getAddressCoordinatesRequest.setAddress(address);
    getAddressCoordinatesRequest.setCity(geoName);
    getAddressCoordinatesRequest.setCountry(countryGeoName);
    const response: GetAddressInGeologicResponse = await this.getAddressInGeologicCall(
      getAddressCoordinatesRequest
    );
    if (response.getStatus().getStatus() !== StatusInfoResponse.StatusType.SUCCESS) {
      throw new MuException(
        this.getAddressError(
          response?.getStatus()?.getMessage(),
          response?.getStatus()?.getErrorcode()
        )
      );
    }
    if (!response.getData().getProperties().getCity()) {
      throw new MuException(
        this.getAddressError('Dirección inválida', StatusInfoResponse.ErrorCode.GENERAL_ERROR)
      );
    }
    return {
      latitude: response.getData().getCoordinates().getLatitude(),
      longitude: response.getData().getCoordinates().getLongitude(),
      city: response.getData().getProperties().getAdmin3(),
      geoName: response.getData().getProperties().getCity(),
    };
  }

  /**
   * method to calculate price and distance for create order
   *
   * @param {OrderToCreate} orderToCreate Order data to create
   * @param {boolean} isFromCreate? is from create this request
   */
  async calculateDistance(
    orderToCreate: OrderToCreateShared,
    country: CountryShared,
    isFromCreate?: boolean
  ): Promise<OrderDistanceShared> {
    const calculateDistanceRequest = new GetCalculationDistanceRequest();
    calculateDistanceRequest.setUserid(orderToCreate.userId);
    calculateDistanceRequest.setServicetype(orderToCreate.serviceType);
    calculateDistanceRequest.setRoundtrip(orderToCreate.roundTrip);
    calculateDistanceRequest.setDeclaredvalue(parseFloat(orderToCreate.declaredValue));
    calculateDistanceRequest.setCity(isFromCreate ? orderToCreate.city : orderToCreate.cityBase);
    calculateDistanceRequest.setOrdertype(
      orderToCreate.orderType === -1 ? 0 : orderToCreate.orderType
    );
    calculateDistanceRequest.setPointid(orderToCreate.pointId);
    calculateDistanceRequest.setStartdate(orderToCreate.startDate);
    calculateDistanceRequest.setStarttime(orderToCreate.startTime);
    const coordinateList: DeliveryCoordinates[] = [];

    for (const [_, coordinate] of orderToCreate.coordinates.entries()) {
      const newCoordinate: DeliveryCoordinates = new DeliveryCoordinates();
      const newClientData: CoordinatesClientData = new CoordinatesClientData();
      newClientData.setPaymenttype(
        isFromCreate ? orderToCreate.userPaymentType : coordinate.paymentTypeId + ''
      );
      newCoordinate.setPointid(coordinate.pointClientId || coordinate.pointId);
      newCoordinate.setAddress(coordinate.address);
      newCoordinate.setLatitude(coordinate.latitude + '');
      newCoordinate.setLongitude(coordinate.longitude + '');
      newCoordinate.setCity(coordinate.city);
      newCoordinate.setType(coordinate.type);
      newCoordinate.setClientdata(newClientData);
      coordinateList.push(newCoordinate);
    }
    calculateDistanceRequest.setCoordinatesList(coordinateList);
    const response = await this.getCalculationDistanceCall(calculateDistanceRequest);
    const error =
      response.getStatus().getStatus() !== StatusInfoResponse.StatusType.SUCCESS ||
      response?.getStatus().getErrorcode() !== StatusInfoResponse.ErrorCode.OK;
    if (error) {
      throw new MuException(
        this.getAddressError(
          response?.getStatus()?.getMessage(),
          response?.getStatus()?.getErrorcode()
        )
      );
    }
    if (!error) {
      const data = response.getData();
      return {
        totalService: this.utilsService.formatCurrency(data.getTotalservice(), country),
        distance: data.getTotaldistance(),
        parkingSurcharge: data.getParkingsurcharge(),
      };
    }
  }

  /**
   *
   * @param status Staus to filter
   * @param countryId Country to filter cities
   * @returns Cities and filter shared
   */
  async getCityList(status: string = '1', countryId: number = 1): Promise<CityAndToFilterShared> {
    return new Promise((resolve, reject) => {
      const statusValue: string = status !== '' ? `?status=${status}` : '';
      if (!this.Muhttp || !this.Muhttp.get) {
        // Si this.Muhttp.get es undefined, devuelve arrays vacíos
        resolve({
          cityFormatedList: [],
          cityList: [],
        });
        return;
      }
      this.Muhttp.get(`${environment.hostnameApi}/cities/${countryId}${statusValue}`, {}).subscribe(
        data => {
          const cityFormatedList = (data as any).data
            .map(city => {
              return {
                value: city.id,
                label: city.name,
                extra: city.name_geoapps,
              };
            })
            .sort((a, b) => a.label.localeCompare(b.label));
          const cityList: CityShared[] = (data as any).data
            ?.filter(x => x.id !== 0)
            .map(city => {
              return {
                id: city.id,
                name: city.name,
                geoName: city.name_geoapps,
                idCityBase: city.id_city_base,
                latitude: city.latitude,
                longitud: city.longitud,
              };
            })
            .sort((a, b) => a.name.localeCompare(b.name));
          resolve({ cityFormatedList, cityList });
        },
        err => reject(err)
      );
    });
  }

  /**
   * method to calculate distance to edit order or request service in express
   *
   * @param {OrderToCreate} orderDataToCalculateDistance Order data to edit
   * @param {boolean} forExpress is for express basic
   * @return {OrderDistance} response
   */
  async calculateDistanceToEdit(
    orderDataToCalculateDistance: OrderToCreateShared,
    country: CountryShared,
    forExpress?: boolean
  ): Promise<OrderDistanceShared> {
    const calculateDistanceToEditRequest = new GetCalculateRequest();
    calculateDistanceToEditRequest.setUserid(orderDataToCalculateDistance.userId);
    calculateDistanceToEditRequest.setServicetype(orderDataToCalculateDistance.serviceType);
    calculateDistanceToEditRequest.setRoundtrip(orderDataToCalculateDistance.roundTrip);
    calculateDistanceToEditRequest.setCity(orderDataToCalculateDistance.city);
    calculateDistanceToEditRequest.setDeclaredvalue(
      forExpress ? parseFloat(orderDataToCalculateDistance.declaredValue) : 0
    );
    const coordinateList: SimplifiedCoordinates[] = [];

    for (const coordinate of orderDataToCalculateDistance.coordinates) {
      const newCoordinate = new SimplifiedCoordinates();
      newCoordinate.setAddress(coordinate.address);
      newCoordinate.setLatitude(coordinate.latitude);
      newCoordinate.setLongitude(coordinate.longitude);
      newCoordinate.setCity(coordinate.city);
      coordinateList.push(newCoordinate);
    }

    calculateDistanceToEditRequest.setCoordinatesList(coordinateList);
    const response = await this.getCalculateCall(calculateDistanceToEditRequest);
    const addressList = response
      .getData()
      .getAddressdataList()
      .map(x => {
        return {
          city: x.getCity(),
          address: x.getClientaddress(),
        };
      });

    return {
      totalService: this.utilsService.formatCurrency(response.getData().getTotalservice(), country),
      distance: response.getData().getTotaldistance(),
      parkingSurcharge: response.getData().getParkingsurcharge(),
      addressList,
    };
  }

  /**
   * get address error key by status code or api message
   * @param {string} message
   * @param {number} code
   * @returns {RequestError} response
   */
  getAddressError(message: string, code: number): MuExceptionData {
    let key = '';
    switch (code.toString()) {
      case StatusInfoResponse.ErrorCode.INVALID_ADRESS.toString():
        key = RequestAddressErrorKey.NEARBY_CITY;
        break;
      case StatusInfoResponse.ErrorCode.SERVICE_EXCEED_LIMITED_DISTANCE.toString():
        key = RequestAddressErrorKey.KM_RESTRICTION;
        break;
      case StatusInfoResponse.ErrorCode.INVALID_DACLARED_VALUE.toString():
        key = RequestAddressErrorKey.DECLARED_VALUE;
        break;
      case StatusInfoResponse.ErrorCode.IS_NOT_PRINCIPAL_CITY.toString():
      case StatusInfoResponse.ErrorCode.ADDRESS_NOT_INSIDE_POLYGON.toString():
        key = RequestAddressErrorKey.COVERAGE;
        break;
      case StatusInfoResponse.ErrorCode.GENERAL_ERROR.toString():
// eslint-disable-next-line no-case-declarations
        const tmpMessage = message.split(' ').map(x => x.toLowerCase());
        if (tmpMessage.includes(RequestAddressErrorMessage.COVERAGE.toLowerCase())) {
          key = RequestAddressErrorKey.COVERAGE;
          message = '';
        } else if (tmpMessage.includes(RequestAddressErrorMessage.INVALID.toLowerCase())) {
          key = RequestAddressErrorKey.INVALID;
        }
        break;
    }
    key = key || RequestAddressErrorKey.FROM_API;
    return { code, key, message };
  }

  /**
   * get oauth data to login
   * @param {LoginCredentialsShared} loginCredentials
   * @returns {OauthResponseShared} response
   */
  async getOauthData(loginCredentials: LoginCredentialsShared): Promise<OauthResponseShared> {
    const request: OauthTokenRequest = new OauthTokenRequest();
    request.setUsername(loginCredentials.email);
    request.setPassword(loginCredentials.password);
    request.setClientid(environment.clientId);
    request.setClientsecret(environment.clientSecret);
    request.setGranttype('password');

    const response: OauthTokenResponse = await this.getOauthTokenCall(request);

    if (!response?.getAccesstoken()) {
      throw new MuException({});
    }

    return {
      accessToken: response?.getAccesstoken(),
      expiresIn: response?.getExpirationtime(),
      refreshToken: response?.getRefreshtoken(),
      tokenType: response?.getTokentype(),
    };
  }

  /**
   * get user data
   * @param {string} accessToken
   * @returns {UserDataShared} response
   */
  async getUserData(accessToken: string): Promise<UserDataShared> {
    const request: GetResourcesByUserRequest = new GetResourcesByUserRequest();
    request.setAccesstoken(accessToken);

    const response: GetResourcesByUserResponse = await this.getUserDataCall(request);

    const EnterpriseGroupList = response
      .getData()
      .getEnterprisegroupList()
      .map(element => {
        return { idcompany: element.getIdcompany(), didcompany: element.getDidcompany() };
      });

    return {
      administrator: response.getData().getAdministrator(),
      cityId: parseInt(response.getData().getCityid(), 10),
      cityName: response.getData().getCityname(),
      companyId: response.getData().getCompanyid(),
      companyName: response.getData().getCompanyname(),
      countryId: response.getData().getCountryresources(),
      createdAt: response.getData().getCreateat(),
      email: response.getData().getResourcesemail(),
      id: response.getData().getResourcesid() + '',
      identification: response.getData().getIdentification(),
      lastVisitAt: response.getData().getLastvisitat(),
      name: response.getData().getUsername(),
      servicesAmount: response.getData().getServicesnumber(),
      usersAmount: response.getData().getUsersnumber(),
      roleNameList: response.getData().getRolesnamesList(),
      roleIdList: response.getData().getRolesidsList(),
      status: response.getData().getUserstatus(),
      statusUser: response.getData().getResourcestatus(),
      terms: response.getData().getResourceterms(),
      timeEnd: response.getData().getTimeend(),
      userType: parseInt(response.getData().getUsertype(), 10),
      username: response.getData().getUsernickname(),
      viewServices: response.getData().getViewservices(),
      userPhone: response.getData().getCityphone(),
      userPaymentType: response.getData().getTypetaskpayid(),
      companyPaymentType: response.getData().getCompanytypetaskpayid(),
      enterprisegroupList: EnterpriseGroupList,
    };
  }

  /**
   * get default token w/o credentials
   * @returns {OauthTokenShared} response
   */
  async getDefaultOauthToken(): Promise<OauthTokenShared> {
    const request = new OauthTokenRequest();

    request.setClientid(environment.clientId);
    request.setClientsecret(environment.clientSecret);
    request.setGranttype(sharedAuthConstants.authToken.grantType);

    const response: OauthTokenResponse = await this.getOauthTokenCall(request);

    if (!response?.getAccesstoken()) {
      throw new MuException({ message: 'Token does not exist' + JSON.stringify(response) });
    }

    return {
      accesstoken: response?.getAccesstoken(),
      expirationtime: response?.getExpirationtime(),
      refreshtoken: response?.getRefreshtoken(),
      scope: response?.getScope(),
      tokentype: response?.getTokentype(),
    };
  }

  /**
   * method to find order detail
   * @param {string} uuid
   * @param {CountryShared} country
   * @returns {Promise<OrderDetailShared>}
   */
  async getOrderDetailByUuid(uuid: string, country: CountryShared): Promise<OrderDetailShared> {
    const request = new GetDeliveryDetailByUUIDRequest();
    request.setUuid(uuid);
    const response = await this.getDeliveryDetailByUuid(request);
    return this.mapOrderDetail(response, country);
  }

  /**
   * method to find order detail
   * @param {string} id
   * @param {CountryShared} country
   * @returns {Promise<OrderDetailShared>}
   */
  async getOrderDetail(id: string, country: CountryShared): Promise<OrderDetailShared> {
    const request = new GetDeliveryDetailByIdRequest();
    request.setId(id);
    const response = await this.getDeliveryDetailById(request);
    return this.mapOrderDetail(response, country, id);
  }

  /**
   * map order detail
   * @param {GetDeliveryDetailByIdResponse} response
   * @param {CountryShared} country
   * @param {string} id
   * @returns {Promise<OrderDetailShared>}
   */
  async mapOrderDetail(
    response: GetDeliveryDetailByIdResponse,
    country: CountryShared,
    id?: string
  ): Promise<OrderDetailShared> {
    let orderStopMap: OrderStopMapShared = {
      baseOrderStop: null,
      baseWSOrderStop: null,
      orderStop: null,
      clientStop: null,
      clientName: '',
      clientPhone: '',
      paymentTypeId: '',
      hasClientTypeId: false,
      loadingRoundTrip: false,
    };
    const data = response.getData();
    const orderStops: OrderStopShared[] = data.getTaskplacesList().map(orderStop => {
      orderStopMap.baseOrderStop = orderStop;
      orderStopMap = this.setOrderStop(orderStopMap);
      orderStopMap.orderStop.tokenPlaceId = orderStop.getTokentaskplace()
      return orderStopMap.orderStop;
    });

    let statusId = sharedDeliveryConstants.statusEndFailedText.includes(data.getStatusname())
      ? sharedDeliveryConstants.statusList.endFailed
      : data.getStatusid();

    statusId = data.getStatusid() === 100 ? ExpressServiceStatus.IN_PROCESS : statusId;

    const orderDetail: OrderDetailShared = {
      id: id || response.getData().getTaskid().toString(),
      orderId: data.getTaskplacesList()[0].getOrderid(),
      uuid: data.getUuid(),
      statusId,
      extratime: data.getExtratime(),
      surchargestops: data.getSurchargestops(),
      surchargedistance: data.getSurchargedistance(),
      roundtripsurcharge: data.getRoundtripsurcharge(),
      startDate: data.getStartdate(),
      startTime: data.getStarttime(),
      defaultWayToPayId: data.getWaytopay(),
      wayToPayId: parseInt(orderStopMap.paymentTypeId, 10),
      totalService: this.utilsService.formatCurrency(data.getTotalservice(), country),
      total: data.getTotalservice(),
      distance: data.getDistance(),
      roundTrip: data.getRoundtrip(),
      initialRoundTrip: data.getRoundtrip(),
      clientName: data.getDatauser().getUsername(),
      clientPhone: data.getDatauser().getUserphone(),
      contactPhone: '',
      contactName: '',
      description: data.getDescription(),
      serviceType: data.getServicetype(),
      orderType: data.getOrdertype(),
      declaredValue: data.getDeclaredvalue(),
      valueDeclared: data.getDeclaredvalue().toString(),
      segmentationId: data.getSegmentationid(),
      createdDateTime: data.getCreationdate(),
      updatedDateTime: data.getUpdateddatetime(),
      parkingSurcharge: data.getParkingsurcharge(),
      resource: {
        name: data.getResource() ? data.getResource().getResourcesname() : '',
        identification: data.getResource() ? data.getResource().getNumberid() : '',
        phone: data.getResource() ? data.getResource().getPhone() + '' : '',
        plateNumber: data.getResource() ? data.getResource().getPlatenumber() : '',
        vehicleType: data.getResource() ? data.getResource().getTyperesourcename() : '',
        photo: data.getResource() ? data.getResource().getPhoto() : '',
      },
      orderStops,
      cityName: orderStops.find(x => x.cityName)?.cityName,
      cityId: parseInt(data.getCityid() + '', 10),
      instructions: orderStops.find(x => x.description)?.description,
      userData: {
        id: '' + data.getDatauser().getUserid(),
        username: data.getDatauser().getUsername(),
        name: data.getDatauser().getUsername(),
        userPhone: data.getDatauser().getUserphone(),
        email: data.getDatauser().getUseremail(),
        companyId: '' + data.getDatauser().getCompanyid(),
        companyName: data.getDatauser().getCompanyname(),
        companyPhone: data.getDatauser().getCompanyphone(),
        companyDocumentNumber: data.getDatauser().getCompanynit(),
        companyUrlLogo: '',
        cityId: parseInt(data.getCityid() + '', 10),
        cityName: orderStops.find(x => x.cityName)?.cityName,
      },
    };

    orderDetail.orderStops = this.setOrderStopStore(orderDetail.orderStops, 0);
    orderStopMap = this.setLoadingRoundTrip(orderStopMap, orderDetail);
    orderDetail.loadingRoundTrip = orderStopMap.loadingRoundTrip;
    const isRoundTrip = orderDetail.roundTrip || orderDetail.loadingRoundTrip;

    if (isRoundTrip) {
      orderDetail.orderStops = this.setLastStop(orderDetail.orderStops);
    }

    orderStopMap = this.setClientStop(orderStopMap, orderStops, isRoundTrip);
    orderDetail.contactName = orderStopMap.clientName;
    orderDetail.contactPhone = orderStopMap.clientPhone;

    if (orderDetail.orderType !== OrderType.PRESCRIPTION) {
      orderDetail.wayToPayId = this.setPaymentType(orderDetail, data.getServicetype());
    }
    return orderDetail;
  }

  /**
   * set order stop formated for order detail
   * @param {OrderStopMap} orderStopMap
   * @returns {OrderStopMap} response
   */
  setOrderStop(orderStopMap: OrderStopMapShared): OrderStopMapShared {
    orderStopMap.paymentTypeId =
      orderStopMap.paymentTypeId ||
      orderStopMap.baseWSOrderStop?.payment_type ||
      orderStopMap.baseOrderStop?.getPaymenttype();
    orderStopMap.clientName =
      orderStopMap.clientName ||
      orderStopMap.baseWSOrderStop?.client_name ||
      orderStopMap.baseOrderStop?.getClientname();
    orderStopMap.clientPhone =
      orderStopMap.clientPhone ||
      orderStopMap.baseWSOrderStop?.client_phone ||
      orderStopMap.baseOrderStop?.getClientphone();
    orderStopMap.cityName =
      orderStopMap.cityName ||
      orderStopMap.baseWSOrderStop?.city_name ||
      orderStopMap.baseOrderStop?.getCityname();
    orderStopMap.instructions =
      orderStopMap.instructions ||
      orderStopMap.baseWSOrderStop?.instructions ||
      orderStopMap.baseOrderStop?.getDescription();
    const orderStopTypeId = parseInt(orderStopMap.baseWSOrderStop?.type_id + '', 10);
    const newOrderStop: OrderStopShared = this.mapNewOrderStop(orderStopMap, orderStopTypeId);
    if (
      !Number.isNaN(orderStopTypeId) ||
      orderStopTypeId !== null ||
      orderStopMap.baseOrderStop?.getTypeid() !== null
    ) {
      newOrderStop.typeId = parseInt(
        orderStopMap.baseWSOrderStop?.type || orderStopMap.baseOrderStop?.getTypeid(),
        10
      );
      if (newOrderStop.typeId === OrderStopType.CLIENT) {
        orderStopMap.hasClientTypeId = true;
        orderStopMap.clientStop = newOrderStop;
      }
    } else {
      newOrderStop.typeId = OrderStopType.ADDITIONAL;
    }
    orderStopMap.orderStop = newOrderStop;
    return orderStopMap;
  }

  /**
   * map new order stop
   * @param {OrderStopMap} orderStopMap
   * @returns {OrderStop} response
   */
  mapNewOrderStop(orderStopMap: OrderStopMapShared, orderStopTypeId: number): OrderStopShared {
    return {
      address: orderStopMap.baseWSOrderStop?.address || orderStopMap.baseOrderStop?.getAddress(),
      description:
        orderStopMap.baseWSOrderStop?.description ||
        orderStopMap.baseOrderStop?.getDescription().trim(),
      statusId: parseInt(
        (orderStopMap.baseWSOrderStop?.status || orderStopMap.baseOrderStop?.getStatus()) + '',
        10
      ),
      cityName:
        orderStopMap.baseWSOrderStop?.city_name || orderStopMap.baseOrderStop?.getCityname(),
      finishedStatus:
        orderStopMap.baseWSOrderStop?.finished_status ||
        orderStopMap.baseOrderStop?.getFinishedstatus() === 'true',
      paymentTypeId:
        orderStopMap.baseWSOrderStop?.payment_type || orderStopMap.baseOrderStop?.getPaymenttype(),
      productsValue:
        orderStopMap.baseWSOrderStop?.products_value ||
        orderStopMap.baseOrderStop?.getProductsvalue() + '',
      lat: orderStopMap.baseWSOrderStop?.latitude || orderStopMap.baseOrderStop?.getLatitude(),
      lng: orderStopMap.baseWSOrderStop?.longitude || orderStopMap.baseOrderStop?.getLongitude(),
      clientName:
        orderStopMap.baseWSOrderStop?.client_name || orderStopMap.baseOrderStop?.getClientname(),
      clientPhone:
        orderStopMap.baseWSOrderStop?.client_phone || orderStopMap.baseOrderStop?.getClientphone(),
      isRoundTrip: false,
      id:
        orderStopMap.baseWSOrderStop?.global_task_place_id ||
        orderStopMap.baseOrderStop?.getTaskplaceid(),
      typeId: orderStopTypeId,
    };
  }

  /**
   * set order sotp store on index for order detail
   * @param {OrderStop[]} orderStops
   * @param {number} index
   * @returns {OrderStop[]} response
   */
  setOrderStopStore(orderStops: OrderStopShared[], index: number): OrderStopShared[] {
    orderStops[index].typeId = OrderStopType.STORE;
    return orderStops;
  }

  /**
   * set loading roundtrip for order detail
   * @param {OrderStopMap} orderStopMap
   * @param {OrderDetail} orderDetail
   * @returns {OrderStopMap} response
   */
  setLoadingRoundTrip(
    orderStopMap: OrderStopMapShared,
    orderDetail: OrderDetailShared
  ): OrderStopMapShared {
    orderStopMap.loadingRoundTrip =
      orderDetail.wayToPayId === WayToPay.DATAPHONE ||
      orderDetail.wayToPayId === WayToPay.CASH_ROUND_TRIP;
    return orderStopMap;
  }

  /**
   * set last stop for order detail
   * @param {OrderStop[]} orderStops
   * @returns {OrderStop[]} response
   */
  setLastStop(orderStops: OrderStopShared[]): OrderStopShared[] {
    orderStops[orderStops.length - 1].isRoundTrip = true;
    orderStops[orderStops.length - 1].typeId = OrderStopType.STORE;
    return orderStops;
  }

  /**
   * set client stop for order detail
   * @param {OrderStopMap} orderStopMap
   * @param {OrderStop[]} orderStops
   * @param {boolean} isRoundTrip
   * @returns {OrderStopMap} response
   */
  setClientStop(
    orderStopMap: OrderStopMapShared,
    orderStops: OrderStopShared[],
    isRoundTrip: boolean
  ): OrderStopMapShared {
    if (!orderStopMap.hasClientTypeId) {
      try {
        orderStopMap.clientStop =
          orderStops[isRoundTrip ? orderStops.length - 2 : orderStops.length - 1];
        orderStopMap.clientStop.typeId = OrderStopType.CLIENT;
      } catch (e) {
        orderStopMap.clientStop = orderStops[orderStops.length - 1];
      }
    }
    return orderStopMap;
  }

  /**
   * set poayment type for order detail
   * @param {OrderDetail} orderDetail
   * @param {number} serviceType
   * @returns {number} response
   */
  setPaymentType(orderDetail: OrderDetailShared, serviceType?: number): number {
    const isCash =
      orderDetail.wayToPayId === WayToPay.CASH &&
      orderDetail.orderStops[orderDetail.orderStops.length - 1].typeId === OrderStopType.STORE;
    const cashWayToPay = isCash ? WayToPay.CASH_ROUND_TRIP : orderDetail.wayToPayId;
    return orderDetail.serviceType !== ServiceTypeEnum.SERVICE_DOMICILIOS
      ? serviceType
      : cashWayToPay;
  }

  /**
   * get history list for express service
   *
   * @param {string} id
   * @param {number} statusId
   * @param {string} timeZone
   * @returns {PackageDetailTrackStatus[]} response
   */
  async getServiceHistory(
    id: string,
    statusId: number,
    timeZone: string
  ): Promise<PackageDetailTrackStopStatusShared[]> {
    const request: GetExpressTaskHistoryRequest = new GetExpressTaskHistoryRequest();
    request.setId(parseInt(id, 10));
    const response: GetExpressTaskHistoryResponse = await this.getServiceHistoryCall(request);
    const serviceHistoryList: PackageDetailTrackStopStatusShared[] = [];

    for (const history of response.getHistoryList()) {
      serviceHistoryList.push(
        this.buildHistoryItem({
          orderStatusId: statusId,
          timeZone,
          utcDate: history.getUtcdate(),
          typeId: history.getTypeid(),
          finishedReasonId: history.getContent().getFinishreasonid(),
          finishedStatus: history.getContent().getFinishstatus(),
          messengerName: history.getContent().getMessenger(),
        })
      );
    }

    return serviceHistoryList;
  }

  /**
   * build history item
   * @param {BaseHistoryItem} baseHistoryItem
   * @returns {PackageDetailTrackStatus} response
   */
  buildHistoryItem(baseHistoryItem: BaseHistoryItemShared): PackageDetailTrackStopStatusShared {
    const date = baseHistoryItem.utcDate.split('T');
    const dateFormated = this.utilsService.formatDateTimeWithTimeZone(
      date[0],
      date[1].split('-')[0].replace('.000Z', ''),
      baseHistoryItem.timeZone
    );

    return {
      statusId:
        baseHistoryItem.typeId === ExpressServiceStatus.END_FAILED &&
        baseHistoryItem.orderStatusId !== ExpressServiceStatus.END_FAILED
          ? ExpressServiceStatus.RELAUNCHED
          : baseHistoryItem.typeId,
      date: dateFormated.startDate,
      time: this.utilsService.getTimeAMPM(dateFormated.startTime.split(':').slice(0, -1).join(':')),
      finishedReasonName:
        baseHistoryItem.finishedReasonId !== 0
          ? this.translateService.instant(
              'endFailedDescription.' + baseHistoryItem.finishedReasonId
            )
          : '',
      finishedStatus: baseHistoryItem.finishedStatus,
      messengerName: baseHistoryItem.messengerName,
    };
  }
}
